import { render, staticRenderFns } from "./CompLista.vue?vue&type=template&id=2d43781c&"
import script from "./CompLista.vue?vue&type=script&lang=js&"
export * from "./CompLista.vue?vue&type=script&lang=js&"
import style0 from "./CompLista.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports